import React from 'react';

const LogoExit = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.799" height="15.474" viewBox="0 0 16.799 15.474">
        <g id="Componente_25_5" data-name="Componente 25 – 5" transform="translate(0.2 0.2)" opacity="0.75">
            <g id="Grupo_720" data-name="Grupo 720">
                <path id="Trazado_119" data-name="Trazado 119" d="M4.675,4.675H9.7a.84.84,0,0,0,.837-.837h0A.84.84,0,0,0,9.7,3H4.675A1.68,1.68,0,0,0,3,4.675V16.4a1.68,1.68,0,0,0,1.675,1.675H9.7a.84.84,0,0,0,.837-.837h0A.84.84,0,0,0,9.7,16.4H4.675Z" transform="translate(-3 -3)" fill="#4bc4ec" stroke="#25252a" strokeWidth="0.4"/>
                <path id="Trazado_153" data-name="Trazado 153" d="M8.951,7.652h0a.824.824,0,0,0,0,1.172l1.591,1.591h-7.7A.84.84,0,0,0,2,11.254H2a.84.84,0,0,0,.837.837h7.7L8.951,13.682a.824.824,0,0,0,0,1.172h0a.824.824,0,0,0,1.172,0l3.006-3.006a.834.834,0,0,0,0-1.181L10.123,7.652A.824.824,0,0,0,8.951,7.652Z" transform="translate(3.025 -3.716)" fill="#4bc4ec" stroke="#25252a" strokeWidth="0.4"/>
            </g>
        </g>
    </svg>
);

export default LogoExit;
